<template>
  <div>
    <div v-if="!disableAutoRedirect" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container>
      <b-row class="dashboard-container">
        <b-col lg="3" md="0" sm="0" cols="0"></b-col>
        <b-col lg="6" md="12" sm="12" cols="12" class="m-0 p-0">
          <h2>{{paymentResultMessage}}</h2>
          <p v-if="!disableAutoRedirect">redirecting...</p>
          <md-button
            class="md-button md-primary md-raised"
            :disabled="!disableAutoRedirect"
            @click="goToDashboard"
          >Back Home</md-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { makePaymentResultCallback } from "../../payments/paymentService.js";
import { BOOKING_STATUS, BOOKING_PAYMENT_STATUS } from "../../bookings/bookingUtil";

export default {
  data() {
    return {
      paymentResultMessage: "",
      disableAutoRedirect: false
    };
  },
  computed: {},
  created() {
    this.hideSideMenu();
    this.reactToPaymentCallbackMessage();
  },
  updated() {},
  methods: {
    hideSideMenu(){
      try{
        this.$emit("emitCustomAction", {action:"hideSideMenu"})
      }catch(ex){}
    },
    async reactToPaymentCallbackMessage() {
      try {
          if (this.$route.query.cancel) {
              this.paymentResultMessage = "Payment cancelled";
              this.disableAutoRedirect = true;
              return;
          }
          var bookingFeePaymentCallback = this.getCallbackPayloadFromQueryParams();
          console.log('/paymentResults | bookingFeePaymentCallback: ', bookingFeePaymentCallback);

          if (!bookingFeePaymentCallback.bookingId) {
              this.goToDashboard();
              return;
          }
          await this.$store.dispatch("editUserViewRole", "tenant");
          // expidite the process of notifying our server about the payment update.
          // payment provider will also make the same request to our servers with the same payload via webhook callbacks so ff this fails, its ok.
          const statusChanged = await makePaymentResultCallback({
              paymentReturnMessage: bookingFeePaymentCallback.origJson,
              mac: bookingFeePaymentCallback.origMac
          });
          if (statusChanged) {
              await this.$store.dispatch('UPDATE_BOOKING_PAYMENT_STATUS', {
                  dealId: bookingFeePaymentCallback.bookingId,
                  status: BOOKING_PAYMENT_STATUS.payment_success,
              });
          }

          this.goToBooking(
              bookingFeePaymentCallback.bookingId,
              bookingFeePaymentCallback.status
          );
      }
      catch (error) {
          console.error('reactToPaymentCallbackMessage', error);
      }
    },
    getCallbackPayloadFromQueryParams() {
      if (this.$route.query.json && this.$route.query.mac) {
        var queryJsonObject = JSON.parse(this.$route.query.json);
        if (
          queryJsonObject.message_type &&
          queryJsonObject.message_type == "payment_return"
        ) {
          if (queryJsonObject.merchant_data == "bookingApplication") {
            var bookingId = queryJsonObject.reference.split("=")[1];

            return {
              origJson: this.$route.query.json,
              origMac: this.$route.query.mac,
              bookingId: bookingId.trim(),
              status: queryJsonObject.status
            };
          }
        }
      }
      return false;
    },
    changedTab(tabId) {
      this.activeTab = tabId;
    },
    updateReloadingDasboardItems(status) {
      this.reloadingDasboardItems = status;
    },
    reloadDashboardItems() {
      this.$refs.bookingsRef.reloadBookings();
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    goToDashboard() {
      this.$router.push({
        name: "dashboard"
      });
    },
    goToBooking(bookingId, paymentStatus) {
      this.$router.push({
        name: "deal",
        params: {
          dealId: bookingId,
          ownerViewingForced: false
        }
      });
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/payments/PaymentResult.vue